import { useEffect, useState } from 'react';

import type { FetchIssueTypeDataProps, JiraIssueTypes } from '../__types__/apiUtils';

import { fetchIssueTypes } from './apiUtils';
import { useBulkCreateLoggingEvents } from './useBulkCreateLoggingEvents';
import { ErrorStates, useSetError } from '../providers/BulkCreateContextProvider';

export const FETCH_ISSUE_TYPES = 'fetch-issue-types';

export const useGetIssueTypes = ({ cloudId, projectId, onComplete }: FetchIssueTypeDataProps) => {
	const [issueTypes, setIssueTypes] = useState<JiraIssueTypes | undefined>(undefined);
	const [loading, setLoading] = useState<boolean>(false);
	const { logRequestFailed } = useBulkCreateLoggingEvents();
	const setError = useSetError();
	useEffect(() => {
		if (!cloudId || !projectId) {
			setIssueTypes(undefined);
			return;
		}
		const fetchIssues = async () => {
			setLoading(true);
			try {
				const data = await fetchIssueTypes({ cloudId, projectId });
				setIssueTypes(data);
				onComplete?.(data);
			} catch (e: Error | unknown) {
				void setError(ErrorStates.ISSUE_TYPE_RETRIEVAL);
				logRequestFailed({ requestName: FETCH_ISSUE_TYPES, errorMessage: (e as Error).message });
			} finally {
				setLoading(false);
			}
		};
		void fetchIssues();
	}, [cloudId, projectId, onComplete, setIssueTypes, logRequestFailed, setError]);
	return { issueTypes, loading };
};
